module.exports = __webpack_public_path__ + "img/leakage-detector-md.5056ef37.svg";